var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 42.6666V41.776C66.6667 37.8506 63.4827 34.6666 59.5573 34.6666H53.3333C51.2116 34.6666 49.1768 35.5095 47.6765 37.0098C46.1762 38.5101 45.3333 40.5449 45.3333 42.6666C45.3333 44.7884 46.1762 46.8232 47.6765 48.3235C49.1768 49.8238 51.2116 50.6666 53.3333 50.6666H58.6667C60.7884 50.6666 62.8232 51.5095 64.3235 53.0098C65.8238 54.5101 66.6667 56.5449 66.6667 58.6666C66.6667 60.7884 65.8238 62.8232 64.3235 64.3235C62.8232 65.8238 60.7884 66.6666 58.6667 66.6666H53.3333C51.2116 66.6666 49.1768 65.8238 47.6765 64.3235C46.1762 62.8232 45.3333 60.7884 45.3333 58.6666M42.6667 34.6666H16M29.3333 34.6666V69.3333M2.66667 2.66663H77.3333V77.3333H2.66667V2.66663Z",
    stroke: "black",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.62172b36933630e1bfe05ca5b59dd142.svg";
export { ForwardRef as ReactComponent };